import { Controller } from '@hotwired/stimulus'
import i18n from '../javascripts/util/i18n'

// Copies the value of `valueValue` (or the trigger's `data-clipboard-value`)
// to the system clipboard and surfaces a brief "copied" affordance on the
// trigger element. Falls back to a textarea + execCommand on browsers
// without the async Clipboard API.
export default class extends Controller {
  static values = { value: String, copiedLabel: String }

  async copy(event) {
    const trigger = event.currentTarget
    const text    = trigger.dataset.clipboardValue || this.valueValue
    if (!text) return

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        this.legacyCopy(text)
      }
      this.flash(trigger)
    } catch (_err) {
      // swallow — silent failure is fine, the value is still visible on screen
    }
  }

  legacyCopy(text) {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.style.position = 'fixed'
    ta.style.opacity  = '0'
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
  }

  flash(trigger) {
    trigger.classList.add('text-emerald-500', 'relative')
    trigger.dataset.copied = 'true'

    trigger.querySelector('[data-clipboard-tip]')?.remove()
    const tip = document.createElement('span')
    tip.dataset.clipboardTip = 'true'
    tip.textContent = this.copiedLabelValue || i18n.t('js.clipboard_copy.copied')
    tip.className = 'absolute bottom-full right-0 mb-2 whitespace-nowrap rounded bg-emerald-600 px-2 py-1 text-xs font-medium text-white shadow-lg z-10'
    trigger.appendChild(tip)

    setTimeout(() => {
      trigger.dataset.copied = 'false'
      trigger.classList.remove('text-emerald-500')
      tip.remove()
    }, 1500)
  }
}
